import { Theme, Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import { removeVehicle } from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";
import Button from "./Button";
import Text from "./Text";

// Calling the removeVehicle action from inside the
// render function makes it so I can't type the function
// correctly

type RemoveVehiclePicks = (id: string) => void;

interface IVehiclesListDispatchProps {
  onRemoveVehicle: (vehicle: Users.VehiclePick) => void;
}
interface IVehiclesListOwnProps {
  removeVehiclePick: RemoveVehiclePicks;
  colors: Theme.Colors;
  vehicles: Users.VehiclePick[];
}
interface IVehiclesListStateProps {
  languageStrings: IStrings;
}
type VehiclesListProps = IVehiclesListDispatchProps &
  IVehiclesListOwnProps &
  IVehiclesListStateProps;

const ListContainer = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
`;
const List = styled("div")`
  background-color: white;
  width: 70vw;
  height: 100%;
  margin: 4vh 0;
  overflow-y: auto;
  padding: 1rem;
  border: 2px solid black;
  border-radius: 12px;
  box-shadow: 1px 2px 1px 1px black;
`;
const ListItem = styled("span")`
  display: grid;
  grid-template-columns: 1fr 3fr 3fr 3rem;
  align-items: center;
  width: 100%;
  margin: 0 1vh;
  padding: 0.5rem 1rem;
  border-bottom: 2px solid black;
  font-size: 2rem;
  :last-of-type {
    border-bottom: none;
  }
`;
const ListTextBox = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 100%;
`;
const ListText = styled(Text)`
  color: black;
  text-align: center;
  font-weight: bold;
  text-shadow: none;
  margin: 1rem;
`;
const RemoveButton = styled(Button)`
  width: 2rem;
  height: 2rem;
  margin: 0;
`;

class VehiclesList extends React.Component<VehiclesListProps> {
  public sort = (vehicles: Users.VehiclePick[]) =>
    vehicles.sort((vehicleA, vehicleB) => {
      const { make: makeA, model: modelA, yearMin: yearA } = vehicleA;
      const { make: makeB, model: modelB, yearMin: yearB } = vehicleB;

      if (yearA > yearB) {
        return 1;
      }
      if (yearA < yearB) {
        return -1;
      }
      if (makeA > makeB) {
        return 1;
      }
      if (makeA < makeB) {
        return -1;
      }
      if (modelA > modelB) {
        return 1;
      }
      if (modelA < modelB) {
        return -1;
      }

      return 0;
    });

  public render() {
    const {
      colors,
      languageStrings: strings,
      removeVehiclePick,
      vehicles,
    } = this.props;

    return (
      <ListContainer>
        <List>
          {vehicles && vehicles.length > 0 ? (
            this.sort(vehicles).map((vehicle, index) => (
              <ListItem key={index}>
                <span>
                  {vehicle.yearMin}-{vehicle.yearMax}
                </span>
                <span> &nbsp;{vehicle.make}</span>
                <span>{vehicle.model}</span>
                <RemoveButton
                  bg={colors.error}
                  onClick={() => removeVehiclePick(vehicle.id)}
                  size="1rem"
                >
                  ✖
                </RemoveButton>
              </ListItem>
            ))
          ) : (
            <ListTextBox>
              <ListText size="1.5rem">{strings.noVehicle1}</ListText>
              <ListText size="1.5rem">{strings.noVehicle2}</ListText>
            </ListTextBox>
          )}
        </List>
      </ListContainer>
    );
  }
}

const mapStateToProps = ({ router: { languageStrings } }: IState) => ({
  languageStrings,
});

const mapDispatchToProps = {
  onRemoveVehicle: removeVehicle,
};

export default connect<
  IVehiclesListStateProps,
  IVehiclesListDispatchProps,
  IVehiclesListOwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(VehiclesList);



// WEBPACK FOOTER //
// ./src/components/VehiclesList.tsx